"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f102 = void 0;
exports.f102 = {
    "francis": [
        36
    ],
    "federation": [
        47,
        108,
        109,
        173,
        202,
        252,
        274,
        275,
        276,
        323,
        395,
        505,
        532,
        597,
        609,
        1031,
        1170,
        1405,
        1406,
        1407,
        1447,
        1448,
        1483,
        1491,
        1492,
        1508,
        1527,
        1677,
        1678,
        1699,
        1740,
        1778,
        1892,
        2231,
        2232,
        2317,
        2318,
        2320,
        2590,
        2648,
        2677,
        3095,
        3215,
        3216,
        3217,
        3270,
        3299,
        3341,
        3342,
        3472,
        3481,
        3506,
        3577,
        3665,
        3682,
        3705,
        3858,
        3859,
        3860,
        3892,
        3896,
        3929,
        3936,
        3937,
        3938,
        4026,
        4027,
        4028,
        4041,
        4042,
        4043,
        4044,
        4045,
        4221,
        4291,
        4520,
        4657,
        4953,
        5049,
        5113,
        5129,
        5250,
        5363,
        5395,
        5481,
        5487,
        5488,
        5624,
        5822,
        5823,
        5896,
        5909,
        5961,
        5966,
        5967,
        5968,
        6433,
        6603,
        6608,
        6610,
        6612,
        6630,
        6664,
        6665,
        6786,
        6866,
        6891,
        6907,
        6981,
        7097,
        7182,
        7302,
        7508,
        7548,
        7753,
        7754,
        7875,
        7906,
        7911,
        7912,
        7946,
        8074,
        8133,
        8134,
        8388,
        8398,
        8406,
        8599,
        8621,
        8622,
        8641,
        8698,
        8816,
        8862,
        8895,
        8911,
        8928,
        8940,
        9060,
        9066,
        9073
    ],
    "french": [
        2418,
        2419,
        2420,
        2421,
        2422,
        2423,
        2424,
        2425,
        2426,
        2427,
        2428,
        2429,
        2430,
        2431,
        2432,
        2433,
        2434,
        2435,
        2436,
        2437,
        2438,
        2439,
        2440,
        2441,
        2442,
        2443,
        2444,
        2445,
        2446,
        2447,
        2448,
        2449,
        2450,
        2451,
        2452,
        2453,
        2454,
        2455,
        2456,
        2457,
        2458,
        2459,
        2460,
        2461,
        2462,
        2463,
        2464,
        2465,
        2466,
        2477,
        6799,
        65,
        1619,
        2469,
        2470,
        2568,
        2571,
        3813,
        6490,
        6722,
        1603,
        4461,
        4712,
        5667,
        7319,
        526,
        2104,
        5021,
        5057,
        5062,
        6219,
        6484,
        7860,
        9024,
        9034
    ],
    "french creole": [
        65
    ],
    "french-lexicon creole": [
        65
    ],
    "french-lexicon": [
        65
    ],
    "french-lexified creole": [
        65
    ],
    "french-lexified": [
        65
    ],
    "furati": [
        70
    ],
    "fembe": [
        162
    ],
    "frukpu": [
        187
    ],
    "fabla aragonesa": [
        314
    ],
    "fabla": [
        314
    ],
    "filifita": [
        355
    ],
    "faso": [
        2487,
        463,
        464,
        2486,
        2488,
        6238,
        648,
        757,
        838,
        1005,
        1022,
        1231,
        1239,
        1246,
        1258,
        1530,
        1590,
        1816,
        1820,
        1827,
        1922,
        1946,
        2031,
        2040,
        2354,
        2366,
        2420,
        2704,
        2824,
        3619,
        3846,
        3904,
        3973,
        4162,
        4270,
        4441,
        4974,
        4975,
        5614,
        5713,
        5747,
        6233,
        6360,
        6536,
        6694,
        6787,
        6789,
        6790,
        6871,
        6926,
        6942,
        7042,
        7167,
        7274,
        7511,
        7742,
        7803,
        8084,
        8178,
        8228,
        8616
    ],
    "francophone asl": [
        463,
        464
    ],
    "francophone": [
        463,
        464,
        6799
    ],
    "franco-africaine": [
        463,
        464
    ],
    "fall indians": [
        502
    ],
    "fall": [
        502
    ],
    "french polynesia": [
        526,
        2453,
        5021,
        5057,
        5062,
        6219,
        6484,
        7860,
        9034
    ],
    "faire": [
        607
    ],
    "faire atta": [
        607
    ],
    "fulumu": [
        637
    ],
    "finge": [
        644
    ],
    "fi": [
        648,
        1239,
        2149,
        2381,
        2382,
        2476,
        2478,
        6545,
        6772,
        6974,
        6980,
        7212
    ],
    "fu": [
        745,
        6124,
        8557
    ],
    "fut": [
        745
    ],
    "fada": [
        841
    ],
    "forest bira": [
        849
    ],
    "forest": [
        2231,
        849,
        3050,
        5197,
        5198,
        5199,
        5200,
        5201,
        8940
    ],
    "fanamaket": [
        875
    ],
    "fjaa": [
        878,
        879
    ],
    "fraase": [
        878,
        879
    ],
    "furu": [
        2496,
        880,
        1229,
        1272
    ],
    "frase": [
        916
    ],
    "finarangao": [
        937
    ],
    "farangao": [
        937
    ],
    "fanawbuid": [
        981,
        7819
    ],
    "farafi": [
        989
    ],
    "fr": [
        1076,
        1325,
        1559,
        2115,
        2418,
        2424,
        2434,
        2469,
        2470,
        2471,
        2477,
        2796,
        3109,
        4493,
        5832,
        5834,
        6064,
        6295,
        6766,
        8420,
        9153
    ],
    "france": [
        1076,
        1325,
        1559,
        2115,
        2418,
        2424,
        2434,
        2469,
        2470,
        2471,
        2477,
        2796,
        3109,
        4493,
        5832,
        5834,
        6064,
        6295,
        6766,
        8420,
        9153
    ],
    "foja": [
        1116
    ],
    "foya": [
        1116
    ],
    "fernandian": [
        1197
    ],
    "fj": [
        1222,
        2150,
        2393,
        2742,
        2940,
        2941,
        4392,
        4414,
        6607,
        8387
    ],
    "fiji": [
        2940,
        2941,
        2393,
        6624,
        8387,
        1222,
        2150,
        2742,
        4392,
        4414,
        6607
    ],
    "fing": [
        1239
    ],
    "formosa": [
        1288,
        1303,
        3463,
        6279,
        8030
    ],
    "favorlang": [
        1303
    ],
    "favorlang-babuza": [
        1303
    ],
    "favorlangsch": [
        1303
    ],
    "fujian": [
        1398,
        1399,
        1400,
        1717,
        4950,
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "foochow": [
        1398,
        1399,
        1400
    ],
    "forom": [
        1422,
        2390
    ],
    "fiforon": [
        1422
    ],
    "facara": [
        1426
    ],
    "fachara": [
        1426
    ],
    "fakara": [
        1426
    ],
    "falam": [
        1428,
        1429,
        1430,
        1431,
        1432
    ],
    "falam chin": [
        1428,
        1429,
        1430,
        1431,
        1432
    ],
    "fallam": [
        1428,
        1429,
        1430,
        1431,
        1432
    ],
    "fm": [
        1445,
        2152,
        3866,
        3880,
        4855,
        5051,
        5432,
        5528,
        5583,
        5748,
        6108,
        6147,
        6258,
        6371,
        7181,
        7949,
        8308,
        8309,
        8735
    ],
    "federated states of micronesia": [
        1445,
        2152,
        3866,
        3880,
        4855,
        5051,
        5432,
        5528,
        5583,
        5748,
        6108,
        6147,
        6258,
        6371,
        7181,
        7949,
        8308,
        8309,
        8735
    ],
    "federated": [
        1445,
        2152,
        3866,
        3880,
        4855,
        5051,
        5432,
        5528,
        5583,
        5748,
        6108,
        6147,
        6258,
        6371,
        7181,
        7949,
        8308,
        8309,
        8735
    ],
    "fáh⁴jmii⁴²": [
        1516
    ],
    "francesco": [
        1568
    ],
    "francisco": [
        3075,
        4593,
        9119,
        1568
    ],
    "farwestern": [
        1595
    ],
    "fali": [
        2336,
        2340,
        2398,
        2399,
        1600,
        9058
    ],
    "fanting": [
        1600
    ],
    "french cree": [
        1603
    ],
    "forro": [
        1607
    ],
    "fôlô": [
        1607
    ],
    "fon": [
        2413,
        1691
    ],
    "fur": [
        2500,
        1730
    ],
    "ferne": [
        1730
    ],
    "fininga": [
        1730
    ],
    "foi": [
        2411,
        1751
    ],
    "fataluku": [
        1774
    ],
    "flanc-de-chien": [
        1826
    ],
    "fóoñi": [
        2038,
        2039
    ],
    "fooñi": [
        2038,
        2039
    ],
    "finallig": [
        2053
    ],
    "ferrarese": [
        2068
    ],
    "feloup": [
        2076
    ],
    "felup": [
        2076
    ],
    "felupe": [
        2076
    ],
    "floup": [
        2076
    ],
    "flup": [
        2076
    ],
    "fulup": [
        2076
    ],
    "fura-pawa": [
        2099
    ],
    "french guiana": [
        2104,
        2436,
        2571,
        9024
    ],
    "finland": [
        2149,
        2381,
        2382,
        2476,
        2478,
        6545,
        6772,
        6974,
        6980,
        7212
    ],
    "fk": [
        2151
    ],
    "falkland islands (malvinas)": [
        2151
    ],
    "falkland": [
        2151
    ],
    "forest enets": [
        2231
    ],
    "fate": [
        2250
    ],
    "farsi": [
        2329,
        6299
    ],
    "fasu": [
        2331
    ],
    "fa d’ambu": [
        2332
    ],
    "fa": [
        2332
    ],
    "fa d'ambu": [
        2332
    ],
    "fa d’ambô": [
        2332
    ],
    "foran": [
        2333
    ],
    "furan": [
        2333
    ],
    "fagani": [
        2334
    ],
    "faghani": [
        2334
    ],
    "finongan": [
        2335
    ],
    "finungwa": [
        2335
    ],
    "finungwan": [
        2335
    ],
    "fali of baissa": [
        2336
    ],
    "faiwol": [
        2337
    ],
    "faita": [
        2338
    ],
    "fang": [
        2339,
        2342
    ],
    "fenga": [
        2339
    ],
    "fang (cameroon)": [
        2339
    ],
    "fali, south": [
        2340
    ],
    "fam": [
        2341
    ],
    "fang (equatorial guinea)": [
        2342
    ],
    "falor": [
        2343
    ],
    "fataleka": [
        2344
    ],
    "fayu": [
        2345
    ],
    "fala": [
        2346
    ],
    "fars, southwestern": [
        2347
    ],
    "fars": [
        2347,
        2348
    ],
    "fars, northwestern": [
        2348
    ],
    "français": [
        2418,
        2419,
        2420,
        2421,
        2422,
        2423,
        2425,
        2426,
        2427,
        2428,
        2429,
        2430,
        2431,
        2432,
        2433,
        2435,
        2436,
        2437,
        2438,
        2439,
        2440,
        2441,
        2442,
        2443,
        2444,
        2445,
        2446,
        2447,
        2448,
        2449,
        2450,
        2451,
        2452,
        2453,
        2454,
        2455,
        2456,
        2457,
        2458,
        2459,
        2460,
        2461,
        2462,
        2463,
        2464,
        2465,
        2424,
        2434,
        2466,
        2350
    ],
    "feroge": [
        2351
    ],
    "feroghe": [
        2351
    ],
    "ferroge": [
        2351
    ],
    "fulah": [
        2352,
        2353,
        2354,
        2355,
        2356,
        2357,
        2358,
        2359,
        2360,
        2361,
        2362,
        2363,
        2364,
        2365,
        2366,
        2367,
        2368,
        2369,
        2370,
        2371,
        2372,
        2373,
        2374,
        2375,
        2376
    ],
    "fulani": [
        2352,
        2365,
        2378,
        2379,
        2482,
        2486,
        2487,
        2488,
        2493,
        2497,
        2498,
        2479,
        2480
    ],
    "fulbe jeeri": [
        2352,
        2365
    ],
    "fulbe": [
        2352,
        2365,
        2378,
        2379,
        2483,
        2484,
        2485,
        2486,
        2487,
        2488,
        2493,
        2497,
        2498,
        2479,
        2480
    ],
    "fulfulde pulaar": [
        2352,
        2365
    ],
    "fulfulde": [
        2378,
        2379,
        2479,
        2480,
        2482,
        2486,
        2487,
        2488,
        2489,
        2493,
        2497,
        2498,
        2352,
        2365,
        2483,
        2484,
        2485
    ],
    "fulfulde-pulaar": [
        2352,
        2365
    ],
    "foia foia": [
        2377
    ],
    "foia": [
        2377
    ],
    "foiafoia": [
        2377
    ],
    "foyafoya": [
        2377
    ],
    "fulfulde, maasina": [
        2378,
        2379
    ],
    "fongoro": [
        2380
    ],
    "finnish": [
        2381,
        2382,
        2395,
        2476,
        6545,
        2391
    ],
    "finska": [
        2381,
        2382
    ],
    "finskiy": [
        2381,
        2382
    ],
    "fadicca": [
        2383,
        2384,
        2385
    ],
    "fadicha": [
        2383,
        2384,
        2385
    ],
    "fadija": [
        2383,
        2384,
        2385
    ],
    "fedicca": [
        2383,
        2384,
        2385
    ],
    "fedija": [
        2383,
        2384,
        2385
    ],
    "fiadidja": [
        2383,
        2384,
        2385
    ],
    "fiadidja-mahas": [
        2383,
        2384,
        2385
    ],
    "fiyadikkya": [
        2383,
        2384,
        2385
    ],
    "fyer": [
        2386
    ],
    "fier": [
        2386
    ],
    "filipino": [
        2387,
        2388,
        6319
    ],
    "fipa": [
        2389
    ],
    "fiba": [
        2389
    ],
    "firan": [
        2390
    ],
    "faran": [
        2390
    ],
    "foron": [
        2390
    ],
    "fəràn": [
        2390
    ],
    "fɨràn": [
        2390
    ],
    "fiwaga": [
        2392
    ],
    "fimaga": [
        2392
    ],
    "fiwage": [
        2392
    ],
    "fijian": [
        2393,
        8387
    ],
    "finnish, kven": [
        2395
    ],
    "foau": [
        2397
    ],
    "fuau": [
        2397
    ],
    "fali of mubi": [
        2398
    ],
    "fali of muchella": [
        2398
    ],
    "fali, north": [
        2399
    ],
    "flinders island": [
        2400
    ],
    "flinders": [
        2400
    ],
    "fuliiru": [
        2401
    ],
    "fulero": [
        2401
    ],
    "fuliiro": [
        2401
    ],
    "fuliru": [
        2401
    ],
    "flaaitaal": [
        2402
    ],
    "flaai taal": [
        2402
    ],
    "flaai": [
        2402
    ],
    "fly taal": [
        2402
    ],
    "fly": [
        2402
    ],
    "fe’fe’": [
        2403
    ],
    "fèʼéfěʼè": [
        2403
    ],
    "fe'fe'": [
        2403
    ],
    "feefee": [
        2403
    ],
    "fefe": [
        2403
    ],
    "fe’efe’e": [
        2403
    ],
    "fotouni": [
        2403
    ],
    "fè-fèè": [
        2403
    ],
    "fè’éfě’è": [
        2403
    ],
    "far": [
        2404,
        6528
    ],
    "far western muria": [
        2404
    ],
    "fanbak": [
        2405
    ],
    "fanbyak": [
        2405
    ],
    "fanagoloi": [
        2406
    ],
    "fania": [
        2407
    ],
    "fagnia": [
        2407
    ],
    "fana": [
        2407
    ],
    "fanian": [
        2407
    ],
    "fanya": [
        2407
    ],
    "fanyan": [
        2407,
        9047,
        9048
    ],
    "faroese": [
        2408,
        2409
    ],
    "føroyskt": [
        2408,
        2409
    ],
    "faeroese": [
        2408
    ],
    "fo": [
        2413,
        4021,
        7046,
        2408
    ],
    "faroe islands": [
        2408
    ],
    "faroe": [
        2408
    ],
    "foodo": [
        2410
    ],
    "fóodo": [
        2410
    ],
    "foe": [
        2411
    ],
    "foma": [
        2412
    ],
    "fuma": [
        2412
    ],
    "fɔngbè": [
        2413
    ],
    "fogbe": [
        2413
    ],
    "fon-gbe": [
        2413
    ],
    "fongbe": [
        2413
    ],
    "fonnu": [
        2413
    ],
    "fore": [
        2414
    ],
    "formosan": [
        2415
    ],
    "fernandino": [
        2416
    ],
    "fernando po creole english": [
        2416
    ],
    "fernando": [
        2416
    ],
    "fernando po krio": [
        2416
    ],
    "fas": [
        2417
    ],
    "francese": [
        2418,
        2424,
        2434
    ],
    "francès": [
        2418,
        2424,
        2434
    ],
    "francés": [
        2418,
        2424,
        2434
    ],
    "frans": [
        2418,
        2424,
        2434,
        8103
    ],
    "frantsay": [
        2418,
        2424,
        2434
    ],
    "französisch": [
        2418,
        2424,
        2434
    ],
    "français canadien": [
        2425
    ],
    "français suisse": [
        2429
    ],
    "futuna": [
        2481,
        2464,
        8265
    ],
    "french, cajun": [
        2466
    ],
    "français cadien": [
        2466
    ],
    "français de la louisiane": [
        2466
    ],
    "français louisianais": [
        2466
    ],
    "françé la lwizyàn": [
        2466
    ],
    "françé": [
        2466
    ],
    "fordata": [
        2467
    ],
    "frankish": [
        2468,
        4217
    ],
    "franco-provençal": [
        2471
    ],
    "francoprovençal": [
        2471
    ],
    "forak": [
        2472
    ],
    "frisian, northern": [
        2473
    ],
    "frisian": [
        2473,
        2503,
        2474,
        5845,
        5846,
        7174
    ],
    "frasch": [
        2473
    ],
    "freesch": [
        2473
    ],
    "freesk": [
        2473
    ],
    "friisk": [
        2473
    ],
    "fräisch": [
        2473
    ],
    "fortsenal": [
        2475
    ],
    "finnish sign language": [
        2476
    ],
    "finsl": [
        2476
    ],
    "french sign language": [
        2477
    ],
    "française": [
        2477,
        7146
    ],
    "finland-swedish sign language": [
        2478
    ],
    "finland-swedish": [
        2478
    ],
    "finssl": [
        2478
    ],
    "finlandssvenskt teckenspråk": [
        2478
    ],
    "finlandssvenskt": [
        2478
    ],
    "fulfulde, adamawa": [
        2479,
        2480
    ],
    "fellata": [
        2479,
        2480
    ],
    "fillanci": [
        2479,
        2480
    ],
    "foulfoulde": [
        2479,
        2480
    ],
    "ful": [
        2479,
        2480
    ],
    "fula": [
        2479,
        2480,
        2483,
        2484,
        2485,
        2486,
        2487,
        2488,
        2493,
        3619,
        2489
    ],
    "fula fulbe": [
        2479,
        2480
    ],
    "fulata": [
        2479,
        2480
    ],
    "fulatanchi": [
        2479,
        2480
    ],
    "futuna, east": [
        2481
    ],
    "futunan": [
        2481
    ],
    "fakafutuna": [
        2481
    ],
    "futunian": [
        2481
    ],
    "futunien": [
        2481
    ],
    "fulfulde, borgu": [
        2482
    ],
    "fulbe-borgu": [
        2482
    ],
    "fulfulde, benin-togo": [
        2482
    ],
    "foula fouta": [
        2483,
        2484,
        2485
    ],
    "foula": [
        2483,
        2484,
        2485,
        3619
    ],
    "fouta": [
        2483,
        2484,
        2485
    ],
    "fouta djallon": [
        2483,
        2484,
        2485
    ],
    "fouta dyalon": [
        2483,
        2484,
        2485
    ],
    "fulfulde jalon": [
        2483,
        2484,
        2485
    ],
    "fullo fuuta": [
        2483,
        2484,
        2485
    ],
    "fullo": [
        2483,
        2484,
        2485
    ],
    "fuuta": [
        2483,
        2484,
        2485
    ],
    "futa": [
        2483,
        2484,
        2485
    ],
    "futa fula": [
        2483,
        2484,
        2485
    ],
    "futa jallon": [
        2483,
        2484,
        2485
    ],
    "fuuta jalon": [
        2483,
        2484,
        2485
    ],
    "fulfulde, western niger": [
        2486,
        2488,
        2487
    ],
    "fulfulde, gorgal": [
        2486,
        2487,
        2488
    ],
    "fulfulde, northeastern burkina faso": [
        2487,
        2486,
        2488
    ],
    "fulfulde, bagirmi": [
        2489
    ],
    "fungor": [
        2490
    ],
    "fungur": [
        2490
    ],
    "fum": [
        2491
    ],
    "fornió": [
        2492
    ],
    "fulniô": [
        2492
    ],
    "furniô": [
        2492
    ],
    "fulfulde, central-eastern niger": [
        2493
    ],
    "friulian": [
        2494
    ],
    "furlan": [
        2494
    ],
    "frioulan": [
        2494
    ],
    "frioulian": [
        2494
    ],
    "friulano": [
        2494
    ],
    "futuna-aniwa": [
        2495
    ],
    "fulfulde, nigerian": [
        2497,
        2498
    ],
    "fulatanci": [
        2497,
        2498
    ],
    "fulfulde, mbororo": [
        2497,
        2498
    ],
    "fulɓe": [
        2497,
        2498
    ],
    "fulfulde caka nigeria": [
        2498
    ],
    "fuyug": [
        2499
    ],
    "fujuge": [
        2499
    ],
    "fuyuge": [
        2499
    ],
    "fuyughe": [
        2499
    ],
    "for": [
        2500
    ],
    "fora": [
        2500
    ],
    "fordunga": [
        2500
    ],
    "forok": [
        2500
    ],
    "forta": [
        2500
    ],
    "four": [
        2500
    ],
    "furakang": [
        2500
    ],
    "furawi": [
        2500
    ],
    "fòòr": [
        2500
    ],
    "fòòraŋ bèle": [
        2500
    ],
    "fòòraŋ": [
        2500
    ],
    "fwâi": [
        2501
    ],
    "fûai": [
        2501
    ],
    "fwe": [
        2502
    ],
    "frysk": [
        2503
    ],
    "fries": [
        2503
    ],
    "french guianese french creole": [
        2571
    ],
    "fakai": [
        2607
    ],
    "fakanchi": [
        2607
    ],
    "fakanci": [
        2607
    ],
    "fakkanci": [
        2607
    ],
    "fyandigere": [
        2611
    ],
    "fyandigeri": [
        2611
    ],
    "fecakomodiyo": [
        2687
    ],
    "fidji-inseln": [
        2742
    ],
    "fiome": [
        2749
    ],
    "farefare": [
        2819
    ],
    "frafra": [
        2819
    ],
    "fãrfãrɛ": [
        2819
    ],
    "fiji baat": [
        2940,
        2941
    ],
    "fiji hindi": [
        2940,
        2941
    ],
    "fiji hindustani": [
        2940,
        2941
    ],
    "faruaru": [
        2954
    ],
    "flowery": [
        2973,
        2974,
        2975,
        6801,
        5723,
        8753,
        8792,
        8805,
        8885,
        8888
    ],
    "flowery miao": [
        2973,
        2974,
        2975
    ],
    "fāngyán": [
        2986
    ],
    "flat head miao": [
        2997,
        2998
    ],
    "flat": [
        2997,
        2998
    ],
    "forest miao": [
        3050,
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "feni": [
        3055
    ],
    "fiterya": [
        3103
    ],
    "fumu": [
        3151
    ],
    "fuumu": [
        3151
    ],
    "feserek": [
        3300
    ],
    "fezere": [
        3300
    ],
    "fizere": [
        3300
    ],
    "fer": [
        3466
    ],
    "fertit": [
        3466
    ],
    "foulse": [
        3619
    ],
    "fulse": [
        3619
    ],
    "fuyu ka’erkezi": [
        3705
    ],
    "fuyu": [
        3705
    ],
    "fuyü gïrgïs": [
        3705
    ],
    "fuyü": [
        3705
    ],
    "fulajon kan": [
        3739,
        3740
    ],
    "fulajon": [
        3739,
        3740
    ],
    "fulajonkan": [
        3739,
        3740
    ],
    "fanating": [
        3893
    ],
    "franconian": [
        6110,
        8109,
        3961,
        4217
    ],
    "fuluka": [
        3975
    ],
    "fo goji": [
        4021
    ],
    "frontera": [
        4058,
        4812,
        8646
    ],
    "fataia": [
        4076
    ],
    "fiu": [
        4078
    ],
    "franco espanyol": [
        4189,
        4190,
        4191
    ],
    "franco": [
        4189,
        4190,
        4191
    ],
    "fak": [
        4293
    ],
    "fa’": [
        4293
    ],
    "franca": [
        4294,
        4295,
        6212
    ],
    "felipe": [
        6265,
        4581,
        5991,
        9168
    ],
    "foré": [
        4620
    ],
    "fiteny malagasy": [
        4736,
        4738
    ],
    "fiteny": [
        4736,
        4738
    ],
    "féri": [
        4857
    ],
    "fagululu": [
        4980
    ],
    "faa ceta": [
        5050
    ],
    "faa": [
        7063,
        5050
    ],
    "formal malay": [
        5067,
        5068,
        5070
    ],
    "formal": [
        5067,
        5068,
        5070
    ],
    "faranah": [
        5075
    ],
    "fila-mele": [
        5209
    ],
    "fesoa": [
        5291
    ],
    "fessoa": [
        5291
    ],
    "fwa-goumak": [
        5393
    ],
    "fadan wate": [
        5480
    ],
    "fadan": [
        5480
    ],
    "flemish": [
        8077,
        8103,
        5536,
        5537,
        5538,
        5539,
        5540,
        5541,
        5542,
        5543
    ],
    "florida islands": [
        5547
    ],
    "florida": [
        5547
    ],
    "fatakai": [
        5600,
        5777
    ],
    "flowery lolo": [
        5723
    ],
    "fuchve": [
        5737
    ],
    "fuch’ye": [
        5737
    ],
    "fugong nu": [
        5737
    ],
    "fugong": [
        5737
    ],
    "fead": [
        5742
    ],
    "fung": [
        5755
    ],
    "fomopea": [
        5763
    ],
    "fontem": [
        5763
    ],
    "fedan": [
        6084
    ],
    "fandanus": [
        6084
    ],
    "francique": [
        6110
    ],
    "fu khla": [
        6124
    ],
    "faake": [
        6125
    ],
    "fakial": [
        6125
    ],
    "filiya": [
        6156
    ],
    "ferenghi": [
        6212
    ],
    "folopa": [
        6274
    ],
    "foraba": [
        6274
    ],
    "fa’awa": [
        6280
    ],
    "foni": [
        6280
    ],
    "fucaka": [
        6280
    ],
    "fuucəka": [
        6280
    ],
    "first nation sign language": [
        6310
    ],
    "first": [
        6310
    ],
    "filipino sign language": [
        6319
    ],
    "fsl": [
        6319
    ],
    "fem": [
        6385
    ],
    "fyam": [
        6385
    ],
    "fyem": [
        6385
    ],
    "ferreñafe": [
        6400
    ],
    "fifia": [
        6519,
        6520,
        6521,
        6522
    ],
    "far eastern manggarai": [
        6528
    ],
    "fíntika rómma": [
        6545
    ],
    "fíntika": [
        6545
    ],
    "fingertalk": [
        6604
    ],
    "fumbira": [
        6635,
        6636
    ],
    "fox": [
        6660
    ],
    "fiti": [
        6750
    ],
    "french belgian sign language": [
        6799
    ],
    "funsile": [
        6872
    ],
    "fa-c-aka": [
        7033
    ],
    "faa saposa": [
        7063
    ],
    "friesen": [
        7174
    ],
    "fallani": [
        7277
    ],
    "fellihi": [
        7277
    ],
    "fako": [
        7293
    ],
    "fehan": [
        7427
    ],
    "fakatikopia": [
        7545
    ],
    "filomena": [
        7576
    ],
    "filomena mata-coahuitlán totonac": [
        7576
    ],
    "fakatonga": [
        7638
    ],
    "faka tonga": [
        7638
    ],
    "faka": [
        7638
    ],
    "foʔu po": [
        7861
    ],
    "foʔu": [
        7861
    ],
    "funtu": [
        7930
    ],
    "fungwa": [
        7944
    ],
    "faur": [
        8003
    ],
    "fagauvea": [
        8033
    ],
    "faga uvea": [
        8033
    ],
    "faga": [
        8033
    ],
    "faga-uvea": [
        8033
    ],
    "flemish sign language": [
        8077
    ],
    "fiot": [
        8083
    ],
    "fiote": [
        8083
    ],
    "flamand": [
        8103
    ],
    "frans vlaams": [
        8103
    ],
    "flamand occidental": [
        8103
    ],
    "flores": [
        8127
    ],
    "foute": [
        8145
    ],
    "fute": [
        8145
    ],
    "fakaʻuvea": [
        8265
    ],
    "fijian, western": [
        8387
    ],
    "ftour": [
        8451
    ],
    "faliscan": [
        8460
    ],
    "flowery phula": [
        8753,
        8792,
        8805,
        8885
    ],
    "flathead phulai": [
        8845
    ],
    "flathead": [
        8845
    ],
    "flowery phu": [
        8888
    ],
    "folk": [
        8916
    ],
    "forest yukagir": [
        8940
    ],
    "funing buyang": [
        8964
    ],
    "funing": [
        8964
    ],
    "fangyan": [
        9020,
        9021,
        9022,
        9030,
        9040,
        9044,
        9045,
        9181,
        9184,
        9188
    ],
    "family": [
        9050
    ],
    "fali of jilbu": [
        9058
    ],
    "funika": [
        9086
    ],
    "francisco león zoque": [
        9119
    ],
    "faranjao": [
        9154
    ],
    "faranjo": [
        9154
    ],
    "faranyao": [
        9154
    ],
    "faranyau": [
        9154
    ],
    "fouh": [
        9181
    ]
};
